import { useAuthStore, type AuthState } from './store'
import { useShallow } from 'zustand/react/shallow'

export { useAuthStore }
export type { AuthState, PermissionAction, PermissionGroup, PermissionMap } from './store'
export type {
  PermissionActionFlags,
  CurrentUser,
  AuthUser,
  RoleItem,
  ViewPermission,
  ViewItems,
  ViewItemEntry,
} from './types'

/**
 * Use with a selector for performance: useAuth(s => s.permission)
 * Without a selector, returns full store (backward-compatible but uses useShallow to reduce re-renders).
 */
export function useAuth(): AuthState
export function useAuth<T>(selector: (state: AuthState) => T): T
export function useAuth<T>(selector?: (state: AuthState) => T) {
  const shallowSelector = useShallow(selector ?? ((s: AuthState) => s as unknown as T))
  return useAuthStore(shallowSelector)
}
